import { Cookies } from 'react-cookie';

export const storageKey = {
  TOKEN: 'token',
  USER_ID: 'userId',
};

export enum CookieKeys {
  token = 'token',
}

const cookies = new Cookies();

// JWT 토큰에서 userId 추출
const getUserIdFromToken = (token: string): string | null => {
  try {
    const payload = token.split('.')[1];
    const decoded = JSON.parse(atob(payload));
    return decoded.userId || decoded.id || decoded.sub || null;
  } catch (error) {
    console.error('토큰 디코딩 실패:', error);
    return null;
  }
};

export const storage = {
  setToken: (token: string) => {
    localStorage.setItem(storageKey.TOKEN, token);
    // 토큰 저장 시 자동으로 userId 추출 및 저장
    const userId = getUserIdFromToken(token);
    if (userId) {
      localStorage.setItem(storageKey.USER_ID, userId);
    }
  },
  getToken: () => localStorage.getItem(storageKey.TOKEN),
  removeToken: () => localStorage.removeItem(storageKey.TOKEN),
  clearToken: () => {
    localStorage.removeItem(storageKey.TOKEN);
    localStorage.removeItem(storageKey.USER_ID);
  },

  setUserId: (userId: string) => localStorage.setItem(storageKey.USER_ID, userId),
  getUserId: () => {
    // localStorage에서 먼저 확인
    let userId = localStorage.getItem(storageKey.USER_ID);
    // 없으면 토큰에서 추출 시도
    if (!userId) {
      const token = localStorage.getItem(storageKey.TOKEN);
      if (token) {
        userId = getUserIdFromToken(token);
        if (userId) {
          localStorage.setItem(storageKey.USER_ID, userId);
        }
      }
    }
    return userId;
  },
  removeUserId: () => localStorage.removeItem(storageKey.USER_ID),
  clearUserId: () => localStorage.removeItem(storageKey.USER_ID),

  set: (key: CookieKeys, value: string) => cookies.set(key, value),
  get: (key: CookieKeys) => cookies.get(key),
  remove: (key: CookieKeys) => cookies.remove(key),
};
